/**
 * Created by Thomas Mark
 * Date: 2020-05-01
 * 
 * VideoFrame
 * 
 * Anzeige eines einzelnes Video-Icon mit der Bezeichnung
 * Bei Klick auf das Video-Icon wird das Video gestartet
 *  
 */

import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Button from '@material-ui/core/Button';
import { Icon } from './Icons';
import UploadArea from "./UploadArea";
import { FabIconDelete } from "./Icons";

import * as utils from "../../basics/utils";
import * as cordova from "../../basics/cordova";
import * as appActions from "../../store/actions/appActions";
import * as fileActions from "../../store/actions/fileActions";
import * as settingActions from '../../store/actions/settingActions';
import * as portfolioActions from '../../store/actions/portfolioActions';

class VideoFrame extends React.Component {
    constructor(props) {
        super(props);

        this.debug = false
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { inputHeight, orientation, path, appModus } = this.props.app;
        const { settingList } = this.props.setting;

        const itemHeight = (orientation === 'landscape') ? inputHeight / 4 : inputHeight / 6

        const width = (this.props.dialog === 'list') ? itemHeight : itemHeight
        const height = width / Math.sqrt(2);

        const dialog = utils.getDialogByPath(path);

        const updateSettingsTutorial = (uploadName) => {
            console.log('updateSettingsTutorial()', uploadName);

            const newSystemSettings = settingList;

            newSystemSettings['tutorial'].videos = uploadName;

            this.props.updateSetting('tutorial', newSystemSettings['tutorial']);
        }

        // ==========================================================================
        // 
        // SUB RENDER
        // 
        // ==========================================================================
        const renderItemNew = () => {
            const style = {
                width: (width) + 'px',
                minWidth: (width) + 'px',
            }

            return (
                <div className="flex w-full h-full border-gray-600 pt-2 pr-2" style={style}>
                    <UploadArea uploadArea='video' uploadType={this.props.type} uploadPath={path} uploadPost='' />
                </div>
            )
        }

        const renderItem = () => {

            const onClick = () => {

                if (window['cordova']) {
                    cordova.viewVideo(this.props.fileName);
                } else {
                    this.props.setModalDialog('MediaModal', this.props.fileName);
                }
            }

            const onDelete = () => {
                const onDeleteSuccess = () => {
                    if (dialog.portfolio) {
                        this.props.scanPortfolio(dialog.portfolio);
                    } else {
                        updateSettingsTutorial([]);
                    }
                }

                const onDeleteError = (error) => {
                    console.log('onDelete() error:', error);
                }

                this.props.deleteFile(this.props.type, path, this.props.fileName, onDeleteSuccess, onDeleteError);
            }

            const fileName = utils.getCommonFileName(this.props.fileName);
            const style = utils.getStyleHeight(height, .1, .08, .08);

            return (
                <div className="relative flex w-full h-full" >
                    <Button className="flex w-full" onClick={onClick}>
                        <div className={"flex justify-center"}>
                            <Icon type='video' width={width} height={height} />
                        </div>
                        <div className={"absolute bottom-2 w-full flex text-center justify-center font-normal text-black"} style={style}>
                            {utils.capitalize(fileName)}
                        </div>
                    </Button>
                    {appModus === 'Admin' && FabIconDelete("Video entfernen", onDelete)}
                </div>
            )
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================

        const style = {
            height: (height) + 'px',
            minHeight: (height) + 'px'
        }

        return (
            <div className={"flex items-start justify-center"} style={style} >
                {this.props.fileName === '_NEW' ? renderItemNew() : renderItem()}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        user: state.user,
        file: state.file,
        setting: state.setting,
        portfolio: state.portfolio,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, fileActions, portfolioActions, settingActions), dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(VideoFrame)
